/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ naam: NonNullable<unknown> }} Planning_Rooster_Pauze_VerplaatsenInputs */

const nl_planning_rooster_pauze_verplaatsen = /** @type {(inputs: Planning_Rooster_Pauze_VerplaatsenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.naam} verplaatsen`)
};

/**

* @param {Planning_Rooster_Pauze_VerplaatsenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_pauze_verplaatsen = /** @type {((inputs: Planning_Rooster_Pauze_VerplaatsenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Pauze_VerplaatsenInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_pauze_verplaatsen(inputs)
});
export { planning_rooster_pauze_verplaatsen as "planning.rooster.pauze_verplaatsen" }